module.exports = __webpack_public_path__ + "img/lottery-1.a1b197ef.svg";